import { useState } from 'react';

interface WhatsAppModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const testimonials = [
  {
    name: 'Carlos Mendes',
    city: 'Campinas – SP',
    avatar: 'CM',
    color: 'bg-yellow-500',
    text: 'Fiquei com medo de pagar antes, mas o guincho chegou em 12 minutos. Profissional, educado e meu carro foi entregue sem nenhum arranhão. Valeu cada centavo!',
    stars: 5,
  },
  {
    name: 'Fernanda Oliveira',
    city: 'Sumaré – SP',
    avatar: 'FO',
    color: 'bg-green-600',
    text: 'Estava sozinha na estrada à noite e precisei de ajuda urgente. Paguei antes conforme orientado e o atendimento foi impecável. Me senti segura do início ao fim.',
    stars: 5,
  },
  {
    name: 'Ricardo Souza',
    city: 'Hortolândia – SP',
    avatar: 'RS',
    color: 'bg-orange-500',
    text: 'A princípio estranhei o pagamento antecipado, mas entendi o motivo. Serviço rápido, sério e sem enrolação. Já indiquei para três amigos.',
    stars: 5,
  },
];

export default function WhatsAppModal({ isOpen, onClose, onConfirm }: WhatsAppModalProps) {
  const [checked, setChecked] = useState(false);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4">
      {/* Overlay */}
      <div
        className="absolute inset-0 bg-black/70 backdrop-blur-sm"
        onClick={onClose}
      />

      {/* Modal */}
      <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="bg-gradient-to-r from-yellow-500 to-yellow-400 rounded-t-2xl px-6 py-5 flex items-start justify-between">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 flex items-center justify-center bg-black/20 rounded-full">
              <i className="ri-shield-check-fill text-white text-xl"></i>
            </div>
            <div>
              <h2 className="text-black font-bold text-lg leading-tight">Aviso Importante</h2>
              <p className="text-black/70 text-sm">Leia antes de prosseguir</p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="w-8 h-8 flex items-center justify-center rounded-full bg-black/10 hover:bg-black/20 transition-colors cursor-pointer"
          >
            <i className="ri-close-line text-black text-lg"></i>
          </button>
        </div>

        <div className="px-6 py-6 space-y-6">

          {/* Alerta de segurança */}
          <div className="bg-red-50 border border-red-200 rounded-xl p-4 flex gap-3">
            <div className="w-8 h-8 flex items-center justify-center shrink-0 mt-0.5">
              <i className="ri-alarm-warning-fill text-red-500 text-2xl"></i>
            </div>
            <div>
              <h3 className="font-bold text-red-700 text-sm mb-1">⚠️ Atenção: Medida de Segurança Obrigatória</h3>
              <p className="text-red-600 text-sm leading-relaxed">
                Registramos <strong>ocorrências de roubos e golpes</strong> na nossa região de atuação. Criminosos utilizam chamadas falsas de guincho para atrair veículos e realizar assaltos próximos à localização do solicitante. Por isso, adotamos uma política de <strong>pagamento antecipado</strong> para garantir a segurança de todos.
              </p>
            </div>
          </div>

          {/* Política de pagamento */}
          <div className="bg-gray-50 rounded-xl p-5 space-y-3">
            <h3 className="font-bold text-gray-900 text-base flex items-center gap-2">
              <span className="w-6 h-6 flex items-center justify-center">
                <i className="ri-money-dollar-circle-fill text-yellow-500 text-xl"></i>
              </span>
              Por que o pagamento é feito no ato do chamado?
            </h3>
            <ul className="space-y-2.5 text-sm text-gray-700">
              <li className="flex items-start gap-2">
                <span className="w-5 h-5 flex items-center justify-center shrink-0 mt-0.5">
                  <i className="ri-checkbox-circle-fill text-green-500 text-base"></i>
                </span>
                <span><strong>Confirmação de identidade:</strong> O pagamento confirma que você é o real solicitante do serviço, evitando chamadas fraudulentas.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="w-5 h-5 flex items-center justify-center shrink-0 mt-0.5">
                  <i className="ri-checkbox-circle-fill text-green-500 text-base"></i>
                </span>
                <span><strong>Proteção da equipe:</strong> Nossos profissionais já foram vítimas de armadilhas. O pagamento antecipado protege a segurança deles no deslocamento.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="w-5 h-5 flex items-center justify-center shrink-0 mt-0.5">
                  <i className="ri-checkbox-circle-fill text-green-500 text-base"></i>
                </span>
                <span><strong>Agilidade no atendimento:</strong> Com o pagamento confirmado, o guincho sai imediatamente para o seu local sem burocracia.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="w-5 h-5 flex items-center justify-center shrink-0 mt-0.5">
                  <i className="ri-checkbox-circle-fill text-green-500 text-base"></i>
                </span>
                <span><strong>Garantia total:</strong> Caso o guincho não chegue no prazo combinado, <strong>devolvemos 100% do valor pago</strong>.</span>
              </li>
            </ul>
          </div>

          {/* Depoimentos */}
          <div>
            <h3 className="font-bold text-gray-900 text-base mb-3 flex items-center gap-2">
              <span className="w-6 h-6 flex items-center justify-center">
                <i className="ri-chat-quote-fill text-yellow-500 text-xl"></i>
              </span>
              O que dizem quem já usou nosso serviço
            </h3>
            <div className="space-y-3">
              {testimonials.map((t) => (
                <div key={t.name} className="bg-white border border-gray-100 rounded-xl p-4 shadow-sm">
                  <div className="flex items-center gap-3 mb-2">
                    <div className={`w-9 h-9 flex items-center justify-center rounded-full ${t.color} text-white font-bold text-sm shrink-0`}>
                      {t.avatar}
                    </div>
                    <div>
                      <p className="font-semibold text-gray-900 text-sm">{t.name}</p>
                      <p className="text-gray-400 text-xs">{t.city}</p>
                    </div>
                    <div className="ml-auto flex gap-0.5">
                      {Array.from({ length: t.stars }).map((_, i) => (
                        <span key={i} className="w-4 h-4 flex items-center justify-center">
                          <i className="ri-star-fill text-yellow-400 text-sm"></i>
                        </span>
                      ))}
                    </div>
                  </div>
                  <p className="text-gray-600 text-sm leading-relaxed italic">"{t.text}"</p>
                </div>
              ))}
            </div>
          </div>

          {/* Checkbox de ciência */}
          <label className="flex items-start gap-3 cursor-pointer group">
            <div className="relative mt-0.5 shrink-0">
              <input
                type="checkbox"
                checked={checked}
                onChange={(e) => setChecked(e.target.checked)}
                className="sr-only"
              />
              <div
                className={`w-5 h-5 rounded border-2 flex items-center justify-center transition-all ${
                  checked ? 'bg-green-500 border-green-500' : 'border-gray-300 group-hover:border-yellow-400'
                }`}
              >
                {checked && <i className="ri-check-line text-white text-xs"></i>}
              </div>
            </div>
            <span className="text-sm text-gray-700 leading-relaxed">
              Estou ciente da política de pagamento antecipado e entendo que ela existe para <strong>minha segurança e da equipe</strong>. Desejo prosseguir com o atendimento.
            </span>
          </label>

          {/* Botões */}
          <div className="flex flex-col sm:flex-row gap-3 pt-1">
            <button
              onClick={onClose}
              className="flex-1 border border-gray-200 text-gray-600 font-medium py-3 rounded-xl hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap text-sm"
            >
              Voltar
            </button>
            <button
              onClick={() => {
                if (checked) onConfirm();
              }}
              disabled={!checked}
              className={`flex-1 font-bold py-3 rounded-xl transition-all flex items-center justify-center gap-2 whitespace-nowrap text-sm ${
                checked
                  ? 'bg-green-500 text-white hover:bg-green-400 shadow-lg hover:shadow-green-500/40 cursor-pointer'
                  : 'bg-gray-100 text-gray-400 cursor-not-allowed'
              }`}
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-whatsapp-fill text-lg"></i>
              </span>
              Estou ciente — Chamar Guincho Agora
            </button>
          </div>

          <p className="text-center text-xs text-gray-400">
            🔒 Seus dados são protegidos. Atendimento 100% seguro e verificado.
          </p>
        </div>
      </div>
    </div>
  );
}
